import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=ba87ce36"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba87ce36')) {
      api.createRecord('ba87ce36', component.options)
    } else {
      api.reload('ba87ce36', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=ba87ce36", function () {
      api.rerender('ba87ce36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Customers/layout.vue"
export default component.exports